import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AutomationService {
  savePrompt(prompt: string): Promise<any> {
    return this.http.post(`${environment.BASE_URL}/ai/automation/web/save-prompt`, { prompt }).toPromise();
  }
  constructor(private http: HttpClient) {}

  async getAllMRIOrders(
    practice_id: string,
    page: number = 1,
    limit: number = 10,
    orderBy: {},
    search: string,
    searchCriteria: string,
  ): Promise<any> {
    return this.http
      .get<any>(`${environment.GET_MRI_AUTOMATION_ORDERS}/${practice_id}`, {
        params: {
          page: `${page}`,
          limit: `${limit}`,
          orderBy: JSON.stringify(orderBy),
          search,
          searchCriteria,
        },
      })
      .toPromise();
  }

  async getLCDCoverage(
    cptCode: string,
    prompt: string,
    policyDocumentData: any,
    ortMastersFiles: File[],
    ortMastersData: any[],
    payer?: string
  ): Promise<any> {
    const formData = new FormData();
    formData.append('cptCode', cptCode);
    formData.append('prompt', prompt);
    if (policyDocumentData) {
      formData.append('policyDocumentId', policyDocumentData);
    }
    if (ortMastersFiles && ortMastersFiles.length > 0) {
      ortMastersFiles.forEach((file) => {
        formData.append('ortMasters', file);
      });
    }
    if (ortMastersData && ortMastersData.length > 0) {
      formData.append('ortMastersData', JSON.stringify(ortMastersData));
    }
    if (payer) {
      formData.append('payer', payer);
    }
     return this.http
      .post<any>(
        `${environment.BASE_URL}/ai/web/generic/lcd-coverage`,
        formData
      )
      .toPromise();
  }

  async getLCDActivePrompt(): Promise<any> {
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/web/lcd-active-prompt`)
      .toPromise();
  }

  async getLastSixMonthsOrtMasters(patient_id:any): Promise<any> {
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/ort-masters/patient/${patient_id}`)
      .toPromise();
  }

  async getLCDByCPT(cpt_code:any,payer:any): Promise<any> {
    const encodedPayer = encodeURIComponent(payer);
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/lcd/cpt/${cpt_code}/payer/${encodedPayer}`)
      .toPromise();
  }

  async getOrderByOrderId(order_id:any): Promise<any> {
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/order/${order_id}`)
      .toPromise();
  }

  async getLCDFileByPayer(payer:any): Promise<any> {
    const encodedPayer = encodeURIComponent(payer);
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/lcd/payer/${encodedPayer}`)
      .toPromise();
  }

  async uploadLcdPolicyDocument(
    file_name: string,
    payer: string,
    description: string,
    lcdDocument: File
  ): Promise<any> {
    const formData = new FormData();
    formData.append('file_name', file_name);
    formData.append('payer', payer.toLowerCase());
    formData.append('description', description ? description : 'NA');
    formData.append('lcdDocument', lcdDocument);

    return this.http
      .post<any>(
        `${environment.BASE_URL}/ai/automation/web/upload-lcd-policy`,
        formData
      )
      .toPromise();
  }

  async searchLcdFiles(search: string): Promise<any> {
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/automation/lcd/files`, {
        params: search ? { search } : {},
      })
      .toPromise();
  }

  async createLcdPolicies(lcd_file_id: string, cpt_from: string, cpt_to?: string): Promise<any> {
    const body: any = { lcd_file_id, cpt_from };
    if (cpt_to) {
      body.cpt_to = cpt_to;
    }
    return this.http
      .post<any>(`${environment.BASE_URL}/ai/automation/web/lcd-policies`, body)
      .toPromise();
  }
}
